import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type CategoriesItemUi = {
  categoryId: string;
  categoryName: string;
  categoryParent: string;
  categoryProductCount: string;
  status?: statusBadgeUi;
};

export type CategoriesUi = {
  columnHeaders: ColumnHeaderUi[];
  items: CategoriesItemUi[];
  searchQuery: string;
  isSearching?: boolean;
  paging?: PagingUi;
  isLoading?: boolean;
};

const tableHeaders = [
  { label: 'ID Categorías' },
  { label: 'Nombre de Categoría' },
  { label: 'Parent' },
  { label: 'Count Productos' },
  { label: 'Estatus' },
  { label: '' },
];

export const initialState: CategoriesUi = {
  columnHeaders: tableHeaders,
  items: [],
  searchQuery: '',
};
